import { useQuery } from '@tanstack/react-query';
import { Card } from '@bruno/ui';
import { adminAuditLogs } from '../api/admin';

export function AuditLogsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin-audit-logs'],
    queryFn: adminAuditLogs,
  });

  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-2xl font-semibold">Audit Log</h1>
      {isLoading ? (
        <div className="text-slate-500">Loading...</div>
      ) : (
        <Card className="p-0 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-slate-600 border-b border-slate-200">
                <tr>
                  <th className="text-left px-4 py-2">When</th>
                  <th className="text-left">Actor</th>
                  <th className="text-left">Action</th>
                  <th className="text-left">Target</th>
                  <th className="text-left">IP</th>
                  <th className="text-left px-4">Payload</th>
                </tr>
              </thead>
              <tbody>
                {(data?.logs ?? []).map((row) => (
                  <tr key={row.id} className="border-b border-slate-100 last:border-0 align-top">
                    <td className="px-4 py-2 whitespace-nowrap">
                      {new Date(row.createdAt).toLocaleString()}
                    </td>
                    <td>{row.actorEmail ?? <span className="text-slate-400">system</span>}</td>
                    <td><code className="text-xs">{row.action}</code></td>
                    <td><code className="text-xs">{row.target ?? '-'}</code></td>
                    <td className="text-xs text-slate-500">{row.ip ?? '-'}</td>
                    <td className="px-4 max-w-xl">
                      {row.payload ? (
                        <pre className="text-xs bg-slate-50 rounded p-2 overflow-x-auto">
                          {JSON.stringify(row.payload, null, 2)}
                        </pre>
                      ) : (
                        <span className="text-slate-400">-</span>
                      )}
                    </td>
                  </tr>
                ))}
                {(data?.logs ?? []).length === 0 ? (
                  <tr>
                    <td colSpan={6} className="text-center text-slate-500 py-6">
                      No log entries.
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
